import styled from "styled-components";

export const ActionButtonsContainer = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    margin-top: -8px;
    margin-bottom: 16px;
    gap: 16px;

    @media (max-width: 576px) {
        flex-direction: column;
        align-items: stretch;
        justify-content: flex-start;
        margin-top: 8px;
        width: 100%;
        gap: 8px;

        > * {
            width: 100%;
        }
    }
`;
